/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VolumeMetadata
 */
export interface VolumeMetadata {
    /**
     * 
     * @type {string}
     * @memberof VolumeMetadata
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMetadata
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMetadata
     */
    area2d: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMetadata
     */
    area3d: string;
    /**
     * 
     * @type {number}
     * @memberof VolumeMetadata
     */
    diffZMax: number;
    /**
     * 
     * @type {number}
     * @memberof VolumeMetadata
     */
    diffZMin: number;
    /**
     * 
     * @type {string}
     * @memberof VolumeMetadata
     */
    cut: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMetadata
     */
    fill: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMetadata
     */
    total: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMetadata
     */
    meshAfter: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMetadata
     */
    meshBefore: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMetadata
     */
    meshDiff: string;
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof VolumeMetadata
     */
    selection_polygon: Array<Array<number>>;
    /**
     * 
     * @type {Array<number>}
     * @memberof VolumeMetadata
     */
    visualCenter: Array<number>;
}

/**
 * Check if a given object implements the VolumeMetadata interface.
 */
export function instanceOfVolumeMetadata(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "area2d" in value;
    isInstance = isInstance && "area3d" in value;
    isInstance = isInstance && "cut" in value;
    isInstance = isInstance && "fill" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "meshAfter" in value;
    isInstance = isInstance && "meshBefore" in value;
    isInstance = isInstance && "meshDiff" in value;
    isInstance = isInstance && "selection_polygon" in value;
    isInstance = isInstance && "visualCenter" in value;

    return isInstance;
}

export function VolumeMetadataFromJSON(json: any): VolumeMetadata {
    return VolumeMetadataFromJSONTyped(json, false);
}

export function VolumeMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'area2d': json['area2d'],
        'area3d': json['area3d'],
        'diffZMax': json['diffZMax'],
        'diffZMin': json['diffZMin'],
        'cut': json['cut'],
        'fill': json['fill'],
        'total': json['total'],
        'meshAfter': json['meshAfter'],
        'meshBefore': json['meshBefore'],
        'meshDiff': json['meshDiff'],
        'selection_polygon': json['selection_polygon'],
        'visualCenter': json['visualCenter'],
    };
}

export function VolumeMetadataToJSON(value?: VolumeMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'area2d': value.area2d,
        'area3d': value.area3d,
        'diffZMax': value.diffZMax,
        'diffZMin': value.diffZMin,
        'cut': value.cut,
        'fill': value.fill,
        'total': value.total,
        'meshAfter': value.meshAfter,
        'meshBefore': value.meshBefore,
        'meshDiff': value.meshDiff,
        'selection_polygon': value.selection_polygon,
        'visualCenter': value.visualCenter,
    };
}
